import React from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
  width: 1130px;
  height: fit-content;
  border: 1px solid #A5BED2;
  padding: 48px 0 32px;
`;

const BoxImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 24px;
`;

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 18px;
`;

const WaringText = styled.span`
  color: #3C4360;
  font-size: 14px;
  opacity: ${props => props.opacity};
`;

const MultiEmpty = () => {
    return (
        <Wrapper>
            <BoxImageWrapper>
                <img
                    src={'images/ico_multi_empty01.jpg'}
                    width={87.7}
                />
            </BoxImageWrapper>
            <TextBox>
                <WaringText opacity={1}>입력하신 소환사명과 일치하는 검색 결과가 존재하지 않습니다. 오타를 확인해주세요.</WaringText>
                <WaringText opacity={"0.7"}>There are no search results matching the name of the summoner you entered. Please check for typos.</WaringText>
            </TextBox>
        </Wrapper>
    );
};

export default MultiEmpty;